(() => {
  if (window.asiAffirmPriceLoaded) return;
  window.asiAffirmPriceLoaded = true;
  const bindings = new Map();
  let refreshTimer;
  const refresh = () => {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(() => {
      if (!window.affirm?.ui?.ready) return;
      window.affirm.ui.ready(() => window.affirm.ui.refresh());
    }, 150);
  };
  const init = () => {
    for (const [promo, cleanup] of bindings) {
      if (!promo.isConnected) { cleanup(); bindings.delete(promo); }
    }
    document.querySelectorAll('[data-asi-affirm-price]').forEach((promo) => {
      if (bindings.has(promo)) return;
      const section = document.getElementById(`MainProduct-${promo.dataset.section}`);
      const price = document.getElementById(`price-${promo.dataset.section}`);
      if (!section || !price) return;
      let timer;
      const update = () => {
        const activePrice = price.querySelector('.price');
        const selector = activePrice?.classList.contains('price--on-sale')
          ? '.price__sale .price-item--sale' : '.price__regular .price-item--regular';
        const text = activePrice?.querySelector(selector)?.textContent.trim() || '';
        const match = text.match(/^(?:USD\s*|US\s*)?\$?\s*(\d{1,3}(?:,\d{3})+|\d+)(?:\.(\d{2}))?\s*(?:USD)?$/);
        const quantityInput = section.querySelector('input[name="quantity"]');
        const quantity = quantityInput ? Number(quantityInput.value) : 1;
        const unit = match ? Number(match[1].replaceAll(',', '')) * 100 + Number(match[2] || 0) : NaN;
        const amount = unit * quantity;
        const valid = promo.dataset.currency === 'USD' && Number.isSafeInteger(amount) && amount > 0
          && Number.isSafeInteger(quantity) && quantity > 0 && !price.classList.contains('visibility-hidden');
        const wasHidden = promo.hidden;
        promo.hidden = !valid;
        if (!valid) return;
        if (promo.getAttribute('data-amount') !== String(amount) || wasHidden) {
          promo.setAttribute('data-amount', String(amount));
          refresh();
        }
      };
      const schedule = () => { clearTimeout(timer); timer = setTimeout(update, 100); };
      const observer = new MutationObserver(schedule);
      observer.observe(price, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class'] });
      section.addEventListener('change', schedule);
      section.addEventListener('input', schedule);
      bindings.set(promo, () => {
        observer.disconnect(); clearTimeout(timer);
        section.removeEventListener('change', schedule);
        section.removeEventListener('input', schedule);
      });
      update();
      refresh();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', () => setTimeout(init, 0));
})();
